<template>
  <v-app class="app">
    <ConfirmDialog ref="confirmDialog"></ConfirmDialog>
    <message></message>
    <snack-bar ref="snackBar"></snack-bar>
    <router-view />
  </v-app>
</template>

<script>
import Vue from 'vue'
import SnackBar from '@components/message/message'
import Message from '@components/message/message-v2'
import ConfirmDialog from '@components/confirm-dialog'
import config from '@/config'

export default {
  name: 'App',
  data: () => ({
    //
  }),
  components: {
    ConfirmDialog,
    Message,
    SnackBar
  },
  created() {
    Vue.prototype.$step = 0
  },
  mounted() {
    Vue.prototype.$snackbar = this.$refs.snackBar
    Vue.prototype.$confirm = this.$refs.confirmDialog

    this.fetchData()
  },
  methods: {
    async fetchData() {
      const res = await fetch(`${config.auth_url}/api/services/assets/stream/configs/menu-apps.json`)
      if (res.ok) {
        const data = await res.json()
        const ai = data.apps.filter(app => app.id === 'ai')[0].name
        console.log(ai)
        document.title = ai
        config.title = ai
      }
    }
  }
}
</script>
<style>
.theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon {
  color: #1726ca !important;
}

.theme--light.v-data-table .v-data-table-header th.sortable:hover,
.theme--light.v-data-table .v-data-table-header th.sortable.active {
  font-size: 14px;
  font-weight: 500;
  color: #1726ca !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  font-size: 14px;
  font-weight: normal;
}

html,
body,
.app {
  width: 100%;
  height: calc(100%);
  overflow-y: hidden;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
}

.fill-height {
  height: 100%;
  min-height: 0;
}

.fill-width {
  width: 100%;
  min-width: 0;
}

.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue